/**
 * @generated SignedSource<<45a4680883693e6b600cb478c398287a>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  /** AppStorageEntityValue */
  AppStorageEntityValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredCustomEntityFieldValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredEntityFieldValue: {
    input: any;
    output: any;
  };
  /** A scalar that can represent arbitrary-precision signed decimal numbers based on the JVMs [BigDecimal](https://docs.oracle.com/javase/8/docs/api/java/math/BigDecimal.html) */
  BigDecimal: {
    input: any;
    output: any;
  };
  /** Supported colors in the Palette */
  CardPaletteColor: {
    input: any;
    output: any;
  };
  /** CardTypeHierarchyLevelType */
  CardTypeHierarchyLevelType: {
    input: any;
    output: any;
  };
  /** A date scalar that accepts string values that are in yyyy-mm-dd format */
  Date: {
    input: any;
    output: any;
  };
  /** A scalar representing a specific point in time. */
  DateTime: {
    input: Date;
    output: Date;
  };
  /**
   * A scalar that enables us to spike [3D](https://relay.dev/docs/glossary/#3d) aka data-driven dependencies
   * This scalar is a requirement for using @match and @module directive supported by Relay GraphQL client
   * Please talk to #uip-app-framework before using this.
   * The definition of the scalar is yet to be decided based on spike insights.
   * To learn about current state see https://go.atlassian.com/JSDependency
   * DO NOT USE: Platform teams are iterating on the final shape of data returned
   */
  JSDependency: {
    input: any;
    output: any;
  };
  /**
   * The `JSON` scalar type represents JSON values as specified
   * by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
   *
   * Note to schema designers - use this scalar with caution as the resultant data becomes untyped
   * from a consumers point of view.  There are legitimate use cases for this scalar type
   * but it SHOULD not be a common scalar.
   */
  JSON: {
    input: {
      [key: string]: any;
    };
    output: {
      [key: string]: any;
    };
  };
  /** A scalar that is a 64-bit signed Java primitive data type. Its range is -2^63 to 2^63 – 1 */
  Long: {
    input: number;
    output: number;
  };
  /** MercuryJSONString */
  MercuryJSONString: {
    input: any;
    output: any;
  };
  /** SoftwareBoardFeatureKey */
  SoftwareBoardFeatureKey: {
    input: any;
    output: any;
  };
  /** SoftwareBoardPermission */
  SoftwareBoardPermission: {
    input: any;
    output: any;
  };
  /** SprintScopeChangeEventType */
  SprintScopeChangeEventType: {
    input: any;
    output: any;
  };
  /** Position for a card - can be a numeric position or relative position ('top' or 'bottom') */
  TrelloCardPosition: {
    input: any;
    output: any;
  };
  /**
   * A unique short string that can be used to fetch a board, card, etc. It's
   * usually used as a part of the entity URL. In some cases can be used as
   * as the ID.
   */
  TrelloShortLink: {
    input: any;
    output: any;
  };
  /** An URL scalar that accepts string values like [https://www.w3.org/Addressing/URL/url-spec.txt]( https://www.w3.org/Addressing/URL/url-spec.txt) */
  URL: {
    input: any;
    output: any;
  };
  /** UUID */
  UUID: {
    input: any;
    output: any;
  };
  /** Upload */
  Upload: {
    input: any;
    output: any;
  };
}
export interface CommentBody {
  representationFormat: ContentRepresentation;
  value: Scalars["String"]["input"];
}
export enum ContentRepresentation {
  ATLAS_DOC_FORMAT = "ATLAS_DOC_FORMAT",
  EDITOR = "EDITOR",
  EDITOR2 = "EDITOR2",
  EXPORT_VIEW = "EXPORT_VIEW",
  PLAIN = "PLAIN",
  RAW = "RAW",
  STORAGE = "STORAGE",
  STYLED_VIEW = "STYLED_VIEW",
  VIEW = "VIEW",
  WIKI = "WIKI",
}
export interface UpdateCommentInput {
  commentBody: CommentBody;
  commentId: Scalars["ID"]["input"];
  /** This field is being deprecated, you do not need to provide this value if the update.comment.mutations.optional.version FF is on */
  version?: InputMaybe<Scalars["Int"]["input"]>;
}
export type EditCommentUpdateCommentMutation_updateComment_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by =

    | EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by_Anonymous
    | EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by_KnownUser
    | EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by_UnknownUser;
export type EditCommentUpdateCommentMutation_updateComment_Comment_version_Version =
  {
    __typename?: "Version";
    number: number | null;
    when: string | null;
    by: EditCommentUpdateCommentMutation_updateComment_Comment_version_Version_by | null;
  };
export type EditCommentUpdateCommentMutation_updateComment_Comment = {
  __typename?: "Comment";
  id: string;
  body?: EditCommentUpdateCommentMutation_updateComment_Comment_body_DocumentBody;
  version?: EditCommentUpdateCommentMutation_updateComment_Comment_version_Version;
};
export type EditCommentUpdateCommentMutation_Mutation = {
  __typename?: "Mutation";
  updateComment: EditCommentUpdateCommentMutation_updateComment_Comment | null;
};
export type EditCommentUpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
  includeVersionFields?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;
export type EditCommentUpdateCommentMutation =
  EditCommentUpdateCommentMutation_Mutation;
